import React, {useEffect, useState} from 'react';
import {Card} from "../../../../components/card/card.jsx";
import {FaArrowLeft, FaTrash} from "react-icons/fa";
import Button from "../../../../components/button/button.jsx";
import projectUtils from "../../../../utils/project-utils.js";
import AlertMessages from "../../../../components/messages/alert-message.js";
import myUserService from "../../../../services/web/my-user-service.js";
import {toast} from "react-toastify";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const MyUserSignature = ({signature, setTarget, refetch, setIsLoading}) => {
    const [img, setImg] = useState(undefined);
    const [imgSrc, setImgSrc] = useState(undefined);
    const [remove, setRemove] = useState(false);

    useEffect(() => {
        if (signature) setImgSrc(`${API_KEEPER}/ged/attach/${signature}`)

        return () => {
            setImg(undefined);
            setImgSrc(undefined);
        }
    }, []);

    const onClick = () => {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*';
        input.onchange = event => processImg(event.target.files[0])
        input.click();
    }

    const onDragOver = (e) => e.preventDefault();

    const onDrop = async (e) => {
        e.preventDefault();

        let file;

        if (e.dataTransfer.items) {
            const items = [...e.dataTransfer.items];
            const firstFileIndex = items.findIndex(item => item.kind === 'file');
            file = items[firstFileIndex]?.getAsFile();
        } else {
            file = [...e.dataTransfer.files][0];
        }

        processImg(file);
    }

    const processImg = (file) => {
        if (!file || !file.type.includes("image")) return;

        const reader = new FileReader();

        reader.onload = ({target: {result}}) => setImgSrc(result);

        reader.readAsDataURL(file);
        setImg(file);
        setRemove(false);
    }

    const removeImg = () => {
        setImg(undefined);
        setImgSrc(undefined);
        setRemove(true);
    }

    const submit = () => {
        if (!remove && !img) return;

        setIsLoading(true)

        const formData = new FormData();
        formData.append("file", img);

        const response = !remove ? myUserService.setSignature(formData) : myUserService.removeSignature();

        response
            .then(() => {
                toast.success("Salvo com sucesso");
                setTarget("info");
                refetch();
            })
            .catch(error => {
                console.error(error);

                const {message} = error.response.data;

                let errMessage = AlertMessages[message] ?? "Não foi possível prosseguir.";
                projectUtils.swalErrorMessage("", errMessage, "Ok");
            })
            .finally(() => setIsLoading(false))
    }

    return (
        <Card>
            <Card.Body>
                <h3 className="flex gap-2 items-center">
                <FaArrowLeft className="cursor-pointer font-normal" onClick={() => setTarget("info")}/>
                    Assinatura
                </h3>

                <div className={"p-3"}>
                    <div style={{height: "calc(100vh - 530px)", border: "1px dashed #000", borderRadius: "5px"}}>
                        {
                            !imgSrc ?
                                <div className="flex justify-center items-center h-full cursor-pointer select-none" onClick={onClick} onDragOver={onDragOver}
                                     onDrop={onDrop}>
                                    <h2 className={"m-0 font-bold"}>Clique aqui ou arraste para enviar o arquivo</h2>
                                </div>
                                :
                                <div className="h-full overflow-hidden p-1"
                                     style={{
                                         backgroundPosition: "50% center",
                                         backgroundSize: "contain",
                                         backgroundRepeat: "no-repeat",
                                         backgroundImage: imgSrc ? `url(${imgSrc})` : ""
                                     }}>
                                    {
                                        imgSrc &&
                                        <Button target="danger" className={"float-right"} onClick={removeImg} style={{position: "absolute", top: "80px", right: "35px"}}>
                                            <FaTrash />
                                        </Button>
                                    }
                                </div>
                        }
                    </div>
                </div>

                <div className="flex justify-end p-[15px]">
                    <Button onClick={submit} actionFeedbackType='save'>

                        Salvar
                    </Button>
                </div>
            </Card.Body>
        </Card>
    );
};

export default MyUserSignature;